let append_to_element = (actionData) => {
    let $el = $(actionData.selector);
    $el.append(actionData.html);
};
export default append_to_element;